const patientDetailsSchema = {
    patient_name:"",
    father_husband_name:"",
    patient_type:"",
    gender:"",
    system_number:"",
    dob:"",
    mobile:"",
    age:"",
    patient_cnic:"",
    unit_name:"",
    district_name:""
}
module.exports = { patientDetailsSchema };